export function getChildFieldSchema(schema, key) {
    var _a;
    if (schema.type === 'object') {
        return schema.properties[key];
    }
    else if (schema.type === 'array') {
        return schema.items;
    }
    else if (schema.type === 'map') {
        return schema.values;
    }
    else if (schema.type === 'any') {
        return schema;
    }
    else if (!('type' in schema)) {
        return (_a = schema[key]) !== null && _a !== void 0 ? _a : null;
    }
    return null;
}
//# sourceMappingURL=children.js.map